<template>
    <span>
        <currency-symbol v-if="!number.hideSymbol" :currency-context="$getAccount().currencyContext"/>
        <span>{{this.number.value}}</span>
    </span>
</template>

<script>
import NumberUtil from '../util/NumberUtil';
import CurrencySymbol from "./CurrencySymbol";

export default {
    name : 'money',
    components : {CurrencySymbol},
    props : {
        value : [String, Number],
        decimals : {
            type : Number,
            default : 2,
        },
        or : {
            type : String,
            default : 'Unknown',
        },
    },
    computed : {
        number () {
            if(this.value === null || this.value === undefined){
                return { value : this.or ? this.or : 'Unknown', hideSymbol : true };
            }
            if(this.value === 0) {
                return { value : '0.00' };
            }
            return { value : NumberUtil.withCommas(this.value, this.decimals, true) };
        }
    }
}
</script>
